import { useQuery } from "@tanstack/react-query";

import { axios } from "@/admin/libs/axios";

export interface AuditLogRow {
  id: string;
  actorId: string;
  actorEmail: string | null;
  action: string;
  target: string | null;
  meta: Record<string, unknown> | null;
  createdAt: string;
}

export interface AuditLogResponse {
  rows: AuditLogRow[];
  total: number;
}

export interface AuditQuery {
  take?: number;
  skip?: number;
  action?: string;
  actorId?: string;
  target?: string;
}

export const fetchAdminAudit = async (query: AuditQuery = {}): Promise<AuditLogResponse> => {
  const { data } = await axios.get<AuditLogResponse>("/admin/audit", { params: query });
  return data;
};

export const useAdminAudit = (query: AuditQuery = {}) =>
  useQuery({
    queryKey: ["admin", "audit", query],
    queryFn: () => fetchAdminAudit(query),
    staleTime: 10_000,
  });
